import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ZoneConfigService {
  readonly enabled = environment.zones.enabled;
}
